import { useCallback } from 'react';
import { ANNOTATION_EVENT_NAMES } from '../../../../../analytics/event-name';
import useAnalytics from '../../../../../analytics/useAnalytics';
import type { ChangeControlsPayloadT } from '../../../analytics/types';
const useAnalyticsFoStageToolBar = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventChangeControls = useCallback((payload: ChangeControlsPayloadT) => {
    sendEvent({
      action: ANNOTATION_EVENT_NAMES.CHANGE_CONTROLS,
      payload
    });
  }, [sendEvent]);
  return {
    sendEventChangeControls
  };
};
export default useAnalyticsFoStageToolBar;